import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import bindAll from 'lodash.bindall';
import LibraryComponent from '../../../components/library/library-no-modal';

class ProjectList extends React.PureComponent {
    constructor(props) {
        super(props);
        bindAll(this, [
            'handleItemSelect'
        ]);
    }

    handleItemSelect(item) {
        if (this.props.match.params.filter == 'myshare') {
            this.props.history.push(`/project/${item.id}?type=share`);
        } else {
            if (item.id || item.id === 0) {
                this.props.history.push("/project/" + item.id);
            } else {
                window.open('https://v1.scratch-edu.com/#/projects', '_blank');
            }
        }
    }
    render() {
        let items = this.props.items.map(item => ({
            id: item.id,
            name: item.title,
            rawURL: item.id || item.id === 0 ? window.config.staticURL + '/thumb/' + (item.id || 'default') + '.png' : `../../../../static/old-products.png`,
            //iconURL: ""
            //insetIconURL: ""
            featured: true,
            //description: item.desc,
            projectType:this.props.match.params.filter&&this.props.match.params.filter
        }));
        return (
            <React.Fragment>
                {/*<img style={{position: "absolute", zIndex:1, left:"18px", top:"21px"}} src={require('./new.png')} />*/}
                <LibraryComponent
                    allowDelete={this.props.allowDelete}
                    data={items}
                    filterable={false}
                    id="ProjectLibrary"
                    title="项目列表"
                    visible={true}
                    onItemSelected={this.handleItemSelect}
                    onRequestClose={this.props.onRequestClose}
                />
            </React.Fragment>
        );
    }
}

ProjectList.propTypes = {
    allowDelete: PropTypes.bool,
    items: PropTypes.arrayOf(PropTypes.object),
    onRequestClose: PropTypes.func
}

export default withRouter(ProjectList);
